// TODO: MAX CLASS
import * as React from "react";
import { findIndex, isUndefined } from "lodash";
import { Alert, Button, Panel } from "react-bootstrap";
import { createControl, IControlError, IControlSchema } from "../../../core/Controls";
import { Component, getRandomKey } from "../../helpers/Utils";
import { IDispatcher } from "../../helpers/Dispatcher";
import { Dictionary } from "../../../types/Dictionary";

interface Props {
	metadata: Array<IControlSchema>;
	dispatcher: IDispatcher;
	disabled: boolean;
	api: any;
	errors: Dictionary<IControlError | undefined>;
	visited: Dictionary<boolean>;
	allVisited: boolean;
	values: any;
	rows: Array<{ key: number; controls: Array<{ id: string; name: string }> }>;
	onAdd(row: { key: number; controls: Array<{ id: string; name: string }> });
	onRemove(key: number, isError: boolean);
	onCopy();
}

class PanelCloneRow extends React.Component<{
	id: number;
	controls: Array<{ id: string; name: string }>;
	metadata: Array<IControlSchema>;
	onRemove?: any;
	isError: boolean;
	api: any;
	errors: Dictionary<IControlError | undefined>;
	values: any;
	visited: Dictionary<boolean>;
	allVisited: boolean;
	dispatcher: IDispatcher;
}> {
	getControlSchema(controlId: string) {
		const { metadata } = this.props;

		const idx = findIndex(metadata, (o: IControlSchema) => o.id === controlId);

		return idx > -1 ? { ...metadata[idx] } : null;
	}

	_handleClickRemove = () => {
		this.props.api.isRemovePanelBlock(this.props.id.toString(), {
			success(data) {
				if (data.isRemove === "0") {
					this.props.onRemove(this.props.id, true);
				} else this.props.onRemove(this.props.id, false);
			},
		});
	};

	render() {
		const elemets: Array<React.ReactElement<any>> = [];
		const { controls, api, dispatcher, values, errors, visited, allVisited } = this.props;

		for (const control of controls) {
			let schema = this.getControlSchema(control.name);
			if (schema !== null) {
				let value = null;
				const idx = findIndex(values, (o: any) => o.controlid === control.id);
				if (idx > -1) {
					value = values[idx].value;
				}
				schema = { ...schema, value, id: control.id } as any;

				let element = null;
				if (schema.type.toLocaleUpperCase() === "NUMBER") {
					const d: any = Object.create(dispatcher);
					d.onBlur = (id, _value, s, error) => dispatcher.onAddValueRefresh(id, _value, error);
					element = createControl(schema, api, d, errors, values, visited, allVisited);
				} else {
					element = createControl(schema, api, dispatcher, errors, values, visited, allVisited);
				}

				elemets.push(React.cloneElement(element, { key: `PanelCloneRow.${this.props.id}.${control.id}` }));
			}
		}

		return (
			// @ts-ignore
			<Panel>
				{/*// @ts-ignore*/}
				<Panel.Body>{elemets}</Panel.Body>
				{/*// @ts-ignore*/}
				<Panel.Footer>
					{/*// @ts-ignore*/}
					<Button bsStyle="danger" onClick={this._handleClickRemove}>
						Удалить
					</Button>
					{/*// @ts-ignore*/}
					{this.props.isError && <Alert bsStyle="danger">Перед удалением очистите ВСЕ поля блока</Alert>}
				</Panel.Footer>
			</Panel>
		);
	}
}

class PanelClone extends Component<Props, object> {
	_handleAddRow = () => {
		const row = { key: getRandomKey(), controls: [] };
		for (const ctrl of this.props.metadata) {
			const control = { id: `${ctrl.id}_copy_${row.key}`, name: ctrl.id };
			row.controls.push(control);
		}

		this.props.onAdd(row);
	};

	render() {
		const { api, dispatcher, metadata } = this.props;
		const isCopyRow = (controls: Array<IControlSchema>) => {
			let count = 0;
			for (const ctrl of controls) {
				if (ctrl.type.toLocaleUpperCase() !== "FILE") {
					count++;
				}
			}

			return count > 0;
		};
		return (
			<div>
				{this.props.rows.map((obj: any) => (
					<PanelCloneRow
						key={obj.key}
						id={obj.key}
						controls={obj.controls}
						onRemove={this.props.onRemove}
						metadata={metadata}
						errors={this.props.errors}
						isError={!isUndefined(obj.isError) && obj.isError}
						api={api}
						values={this.props.values}
						allVisited={this.props.allVisited}
						visited={this.props.visited}
						dispatcher={dispatcher}
					/>
				))}
				{/*// @ts-ignore*/}
				<Button bsStyle="primary" disabled={this.props.disabled} onClick={this._handleAddRow}>
					Добавить новый блок
				</Button>
				{isCopyRow(this.props.metadata) && (
					// @ts-ignore
					<Button bsStyle="success" disabled={this.props.disabled} onClick={this.props.onCopy}>
						Добавить блок (без документов)
					</Button>
				)}
			</div>
		);
	}
}

export default PanelClone;
